export const MCQ_VIEW_STATE_KEY = 'mcq_view';
export const MCQ_VALIDATION_STATE = {
  UNKNOWN: 0,
  NOT_SUBMITTED: 1,
  UNSUCCESSFUL_AND_SUBMITABLE_LATER: 2,
  UNSUCCESSFUL_AND_SUBMITABLE: 3,
  UNSUCCESSFUL_AND_NOT_SUBMITABLE: 4,
  SUCCESSFUL: 5,
};
